import { render, staticRenderFns } from "./HelloGroupsCard.vue?vue&type=template&id=6636c81e&scoped=true"
import script from "./HelloGroupsCard.vue?vue&type=script&lang=js"
export * from "./HelloGroupsCard.vue?vue&type=script&lang=js"
import style0 from "./HelloGroupsCard.vue?vue&type=style&index=0&id=6636c81e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636c81e",
  null
  
)

export default component.exports